import { configureStore } from '@reduxjs/toolkit';
import reducer from './Reducers';

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
});

export default store;
